<template lang="html">
  <div class="nav-background-wrapper">
    <div class="nav-wrapper">
      <div class="logo-wrapper">
        <router-link :to="{ name: 'Home', params: { lang: $i18n.locale } }">
          <img src="@/assets/newImges/new-logo.png" alt="logo image" />
        </router-link>
      </div>
      <div class="links-wrapper">
        <router-link
          v-if="
            activeCompetition &&
              isWoting &&
              $route.name !== 'CompetitionRankList'
          "
          :to="{
            name: 'CompetitionRankList',
            params: {
              lang: $route.params.lang,
              id: activeCompetition.cmp_id
            }
          }"
          style="margin-right: 10px;"
        >
          <div class="btn">
            <img
              src="@/assets/icons/check.png"
              alt=""
              style="margin-right: 10px;"
            />
            {{ $t("competitions.tr.vote") }}
          </div>
        </router-link>
        <div
          v-if="getActiveCompetitionData && isPosting"
          @click="openEditWorkSetupModal()"
          class="btn dark"
        >
          {{ $t("competitions.main.edit") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
export default {
  name: "competitionNav",
  data() {
    return {
      activeCompetition: null
    };
  },
  mounted() {
    this.getActiveCompetition();
  },
  methods: {
    async getActiveCompetition() {
      try {
        let params = {
          type: "active"
        };
        let res = await api.getActiveCompetition(params);
        this.activeCompetition = res.data.data;
      } catch (e) {
        console.log(e);
      }
    },
    navigateToEdit(data) {
      this.$store.commit("setCompetitionWork", data);
      this.$router.push({
        name: "CompetitionEntryEdit",
        params: { lang: this.$i18n.locale, id: data.cmp_id }
      });
    },
    openEditWorkSetupModal() {
      let modalData = {
        title: "Enter your code and password to update your entry:",
        ok: data => {
          this.navigateToEdit(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "editWorkSetup"
      };
      eventBus.$emit("openModal", params);
    }
  },
  computed: {
    getActiveCompetitionData() {
      return this.activeCompetition;
    },
    isPosting() {
      if (this.activeCompetition) {
        let now = new Date();
        let start = new Date(
          this.$moment.utc(this.activeCompetition.cmp_from_post)
        );
        let end = new Date(
          this.$moment.utc(this.activeCompetition.cmp_to_post)
        );
        if (now > start && now < end) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isWoting() {
      if (this.activeCompetition) {
        let now = new Date();
        let start = new Date(
          this.$moment.utc(this.activeCompetition.cmp_from_vote)
        );
        let end = new Date(
          this.$moment.utc(this.activeCompetition.cmp_to_vote)
        );
        if (now > start && now < end) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-background-wrapper {
  width: 100%;
  background-color: white;
  position: sticky;
  top: 0px;
  z-index: 2;
  height: 90px;
  box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.06);

  .nav-wrapper {
    display: flex;
    flex-direction: row;
    max-width: 1320px;
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    align-items: center;
    background-color: white;
    white-space: nowrap;

    .logo-wrapper {
      width: 290px;
      min-width: 120px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      img {
        width: 150px;
      }
    }
    .links-wrapper {
      display: flex;
      flex-direction: row;
      margin-left: auto;

      a {
        text-decoration: none;
      }
      .single-link a:hover {
        color: $text-hover-color;
      }
      .single-link.active {
        a {
          border-bottom: 1px solid $main-color;
        }
      }
      .link-wrapper a {
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.01em;
        text-decoration: none;
        text-transform: uppercase;
        color: #8e3e4c;
        text-decoration: none !important;
      }
    }
  }
}
</style>
